import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import { TextInputComponentProps } from "../text-input-component/text-input-component.props";
import "../text-input-component/text-input-component.scss";

const UrlInputField: React.FC<TextInputComponentProps> = ({
    fieldName = "",
    label,
    placeholder = "",
    optional = false,
    disabled,
    value,
    type,
    onChange,
    minlength,
    maxlength,
    isRequired = false,
    isName = false,
    allowSpecialCharacters = false,
    handleBlur,
    isNumber = false,
}) => {
    const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        if (type === "email") {
            const sanitizedValue = value.replace(/[^A-Za-z0-9._%+-@]/g, "");
            const [localPart, domainPart] = sanitizedValue.split("@");

            if (domainPart !== undefined) {
                if (domainPart.includes("..")) {
                    value = `${localPart}@${domainPart.replace(/\.+/g, ".")}`;
                } else if (domainPart.split(".").length > 2) {
                    const parts = domainPart.split(".");
                    const extension = parts.pop();
                    const domain = parts.join(".");
                    value = `${localPart}@${domain}.${extension?.slice(0, 6)}`;
                }
            }
        } else if (isName) {
            event.target.value = value.replace(/[^A-Za-z -]/g, "");
        } else if (allowSpecialCharacters) {
            event.target.value = value.replace(/[^A-Za-z0-9\s&.,'\/#()\-]/g, "");
        } else if (isNumber) {
            const digitsOnly = value.replace(/[^\d]/g, "");
            event.target.value = digitsOnly.slice(0, Number(maxlength));
        }
    };

    return (
        <Box className="input-field-wrapper">
            <div
                className={`form-text-input-component ${isRequired ? "required" : ""}`}
            >
                <InputLabel required={optional} htmlFor={fieldName}>
                    {label}
                </InputLabel>
                <FormControl>
                    <TextField
                        name={fieldName}
                        placeholder={placeholder}
                        required={optional}
                        disabled={disabled}
                        id={fieldName}
                        value={value}
                        onChange={onChange}
                        onBlur={handleBlur}
                        onInput={handleInput}
                        type={type}
                        slotProps={{
                            input: {
                                id: fieldName,
                                name: fieldName,
                                required: optional,
                            },
                        }}
                        inputProps={{
                            minLength: minlength,
                            maxLength: maxlength,
                        }}
                    />
                </FormControl>
            </div>
            <ErrorMessage
                name={fieldName || ""}
                component="div"
                className="error-message"
            />
        </Box>
    );
};

export default UrlInputField;
